export const productList: Record<string, { value: string; label: string; shouldShow?: boolean }> = {
  car: { value: 'car', label: 'Bil', shouldShow: true },
  content: { value: 'content', label: 'Indbo', shouldShow: true },
  travel: { value: 'travel', label: 'Rejse', shouldShow: true },
  injury: { value: 'injury', label: 'Ulykke', shouldShow: true },
  child: { value: 'child', label: 'Børn', shouldShow: true },
  childTB: { value: 'childTB', label: 'Børn Babysam', shouldShow: true },
  house: { value: 'house', label: 'Hus' },
  dog: { value: 'dog', label: 'Hund' },
  cat: { value: 'cat', label: 'Kat' },
  horse: { value: 'horse', label: 'Hest' },
  caravan: { value: 'caravan', label: 'Campingvogn' },
  trailer: { value: 'trailer', label: 'Trailer' },
  cyberinsurance: { value: 'cyberinsurance', label: 'Cyber' }
};

export const getProductValue = (key: string) => {
  const product = Object.values(productList).find((product: any) => [product.value, product.label].includes(key));

  return product?.value ?? '';
};
